"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.button.start': '开始入职',
    'onboarding.button.continue': '继续到步骤',
    'onboarding.button.previous': '上一步',
    'onboarding.button.next': '下一步',
    'onboarding.button.complete': '完成入职',
};
